import {
  observer,
  useTranslation,
  useLocation,
  Link,
} from "../../vendor/api.js";
// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as DestinationsModule from "../../config/destinations.js";
import * as LocaleContext from "../../i18n/I18nProvider.jsx";
import * as DocumentNavigationModule from "../../routing/documentNavigation.js";
import * as LocalizedPathsModule from "../../routing/localizedPaths.js";
import * as DocumentTitlesModule from "../../routing/documentTitles.js";
import * as ClassNamesModule from "../../utils/classNames.js";
let docsTopLinks = [
  {
    labelKey: "footer.topNavTokenPlan",
    href: "https://platform.xiaomimimo.com/token-plan",
  },
  {
    labelKey: "footer.topNavMiMoClaw",
    href: DestinationsModule.clawLoginUrl,
  },
  {
    labelKey: "footer.topNavChatWithMiMo",
    href: DestinationsModule.chatLoginUrl,
  },
];
let DocsTopNav = observer(() => {
  let { t: translate } = useTranslation(),
    { pathname: pathname } = useLocation(),
    { language: language } = (0, LocaleContext.useI18n)(),
    o = (0, DocumentNavigationModule.a8)(),
    r = (0, DocumentNavigationModule.f2)(pathname, language),
    l = (0, LocalizedPathsModule.Qe)(pathname, language);
  return 0 !== o.length && pathname.includes("/docs/") ? (
    <div
      className={
        "max-w-[1440px] mx-auto z-20 w-full border-b border-[var(--color-border-warm)] backdrop-blur-md shadow-[0px_8px_16px_0px_rgba(255,255,255,0.6),0px_4px_8px_0px_rgba(255,255,255,0.2)]"
      }
    >
      <div className={"flex items-center justify-between px-[24px]"}>
        <nav className={"flex gap-[24px] items-center h-full"}>
          {o.map((e) => {
            let t = (0, DocumentTitlesModule.getLocalizedTitle)(e, language),
              o = r?.key === e.key,
              a = (0, DocumentNavigationModule.W1)(e, l);
            return (
              <Link
                key={e.key}
                to={a ?? "#"}
                className={(0, ClassNamesModule.cn)(
                  "flex gap-[8px] items-center justify-center py-[11px] relative whitespace-nowrap text-[14px] leading-[22px] transition-colors",
                  o
                    ? "font-medium text-[rgba(0,0,0,0.85)] border-b-2 border-black"
                    : "font-normal text-[var(--color-text-secondary)] border-b-2 border-transparent hover:text-[rgba(0,0,0,0.75)]",
                )}
              >
                {t}
              </Link>
            );
          })}
        </nav>
        <nav className={"flex gap-[16px] items-center h-full pr-[16px]"}>
          {docsTopLinks.map((t, i) => (
            <span key={t.labelKey} className={"flex items-center gap-[16px]"}>
              {i > 0 && <span className={"w-px h-[15px] bg-[#d9d9d9]"} />}
              <a
                href={t.href}
                target={"_blank"}
                rel={"noopener noreferrer"}
                className={
                  "flex items-center justify-center py-[11px] relative whitespace-nowrap text-[14px] leading-[22px] transition-colors font-normal text-[var(--color-text-secondary)] border-b-2 border-transparent hover:text-[rgba(0,0,0,0.75)] no-underline"
                }
              >
                {translate(t.labelKey)}
              </a>
            </span>
          ))}
        </nav>
      </div>
    </div>
  ) : null;
});
export { docsTopLinks, DocsTopNav };
